import React from 'react';
import Button from '@atlaskit/button';
import { OpenSidebarPayload, useSidebar } from '@css-xp/base';
import { ApolloQueryResult } from '@apollo/client';
import { SoldToAddress } from '@css-xp/graphtypes/src/generated-types-new';
import './customer-address-detail-page-actions.scss';
import { ADVOCATE_ACCESS_TYPE, ADVOCATE_RESOURCE_TYPE, AdvocateAccessWall } from '@css-xp/ppc-access-control';
import { DarkButton } from '@css-xp/ppc-dark-button';

interface CustomerAddressDetailActionsProps {
  transactionAccountId: string;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
  soldToAddress: SoldToAddress;
  isEditAddressDisabled?: boolean;
  isADefaultButton?: boolean;
}

export enum SIDEBAR {
  EDIT_SOLD_TO_ADDRESS = 'editSoldToAddress',
  CREATE_BILLING_PROFILE = 'createBillingProfilePane',
  EDIT_CUSTOMER_NAME = 'editCustomerName',
  DEACTIVATE_SOLD_TO_ADDRESS = 'deactivateSoldToAddress',
}

export const CustomerAddressDetailPageActions = ({
  transactionAccountId,
  refetch,
  soldToAddress,
  isEditAddressDisabled,
  isADefaultButton,
}: CustomerAddressDetailActionsProps) => {
  const { openSidebar } = useSidebar();

  const onClickEditCustomerAddress = () => {
    const openSidebarPayload = {
      sidebarType: SIDEBAR.EDIT_SOLD_TO_ADDRESS,
      payload: {
        transactionAccountId: transactionAccountId,
        refetch: refetch,
        shipToAddress: soldToAddress,
        sidebarType: 'customer address',
        hidePricingEligibility: true,
      },
      sidebarOptions: {
        isOverlay: true,
        sidebarWidth: '600px',
      },
    } as OpenSidebarPayload;
    openSidebar(openSidebarPayload);
  };

  if (isEditAddressDisabled) {
    return null;
  }

  const editText = 'Edit sold-to address';

  return (
    <div className="customer-details-header-actions" data-testid="header-actions">
      <AdvocateAccessWall accessType={ADVOCATE_ACCESS_TYPE.UPDATE} resource={ADVOCATE_RESOURCE_TYPE.SHIP_TO_ADDRESS}>
        {isADefaultButton ? (
          <Button testId="edit-sold-to-address-btn" onClick={onClickEditCustomerAddress}>
            {editText}
          </Button>
        ) : (
          <DarkButton testId="edit-sold-to-address-btn" appearance="primary" onClick={onClickEditCustomerAddress}>
            {editText}
          </DarkButton>
        )}
      </AdvocateAccessWall>
    </div>
  );
};
